export const GET_ALL_SEARCH = 'GET_ALL_SEARCH'
export const GET_ALL_PAST_SEARCH = 'GET_ALL_PAST_SEARCH'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_DASHBOARD = 'GET_ALL_DASHBOARD'
export const GET_EMD_LIST = 'GET_EMD_LIST'
export const GET_USER_AGREEMENT = 'GET_USER_AGREEMENT'
